import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Container, Card, CardBody, CardTitle, Table } from 'reactstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCartPlus, faImage } from '@fortawesome/free-solid-svg-icons';
import { addToCart } from '../../actions/cartActions';
library.add(faCartPlus);
library.add(faImage)

// const base_url_image =
//     "https://locauditooh-newapp-gallery.s3.ap-south-1.amazonaws.com/";
// const convertion_url =
//     "https://d1of1iagj88x89.cloudfront.net/fit-in/512x512/";

class WardMapInfoBox extends Component {

    handleAddToCardtButton = (e) => {
        e.preventDefault();
        this.props.addToCart(this.props.cartItems, this.props.set_marker_data);
    }

    render() {

        const { ward, wardno, total_population, total_males, total_females,
                employment, total_employed,total_male_employed,total_female_employed ,
                literacy, total_literates,total_male_literates, total_female_literates,
                total_children,total_male_children, total_female_children } = this.props.ward_info;
        const { demographic_type } = this.props;
        // const { demographic_headers } = this.props.demographic_headers;
        // let image_url = "#";

        // if (site_map) {
        //     image_url = site_map
        // }


        // if (photos) {
        //     if (photos.length > 0) {
        //         image_url = photos[photos.length - 1].url
        //     }
        // }
        console.log('demographic',demographic_type)
        return <Container style={{ width: '100%', height: '100%' }}>
            <Card>
                <CardBody className="">
                    <CardTitle> {ward} {demographic_type} Details
                    </CardTitle>
                    <Row>
                        {/* <Col xs={5}>
                            <img style={{ cursor: 'pointer', margin: 5 }} alt={image_url} width={140} src={
                                convertion_url + image_url.replace(base_url_image, "")
                            } onClick={() => window.open(image_url, '_blank')} />
                            <Button className="m-1" size="sm" href="#" onClick={this.handleAddToCardtButton.bind(this)}><FontAwesomeIcon icon="cart-plus" /></Button>

                        </Col> */}
                        <Col xs={12}>
                            <Table className="mt-1" bordered striped>
                                {
                                    demographic_type === 'population' &&
                                        <tbody>
                                        <tr>
                                            <th>Ward</th>
                                            <td>{ward ? ward : "Not Available"}</td>
                                            <th>Ward No</th>
                                            <td>{wardno ? wardno : "Not Available"}</td>
                                        </tr>
                                        <tr>
                                            <th>Total Population</th>
                                            <td>{total_population ? total_population : "Not Available"}</td>
                                            <th>Total Male Population</th>
                                            <td>{total_males ? total_males : "Not Available"}</td>
                                            
                                        </tr>
                                        <tr>
                                        <th>Total Female Population</th>
                                            <td>{total_females ? total_females : "Not Available"}</td>
                                        </tr>
                                    </tbody>
                                }

                                {
                                    demographic_type === 'employment' &&
                                        <tbody>
                                        <tr>
                                            <th>Ward</th>
                                            <td>{ward ? ward : "Not Available"}</td>
                                            <th>Ward No</th>
                                            <td>{wardno ? wardno : "Not Available"}</td>
                                        </tr>
                                        <tr>
                                            <th>Employment</th>
                                            <td>{employment ? employment+" %" : "Not Available"}</td>
                                            <th>Total Employed</th>
                                            <td>{total_employed ? total_employed : "Not Available"}</td>
                                            
                                        </tr>
                                        <tr>
                                            <th>Total Male Employed</th>
                                            <td>{total_male_employed ? total_male_employed : "Not Available"}</td>
                                            <th>Total Female Employed</th>
                                            <td>{total_female_employed ? total_female_employed : "Not Available"}</td>
                                        </tr>
                                    </tbody>
                                }

                                {
                                    demographic_type === 'literacy' &&
                                        <tbody>
                                        <tr>
                                            <th>Ward</th>
                                            <td>{ward ? ward : "Not Available"}</td>
                                            <th>Ward No</th>
                                            <td>{wardno ? wardno : "Not Available"}</td>
                                        </tr>
                                        <tr>
                                            <th>Literacy</th>
                                            <td>{literacy ? literacy+ "%" : "Not Available"}</td>
                                            <th>Total Literates</th>
                                            <td>{total_literates ? total_literates : "Not Available"}</td>
                                            
                                        </tr>
                                        <tr>
                                            <th>Total Male Literates</th>
                                            <td>{total_male_literates ? total_male_literates : "Not Available"}</td>
                                            <th>Total Female Literates</th>
                                            <td>{total_female_literates ? total_female_literates : "Not Available"}</td>
                                        </tr>
                                    </tbody>
                                }

                                {
                                    demographic_type === 'children' &&
                                        <tbody>
                                        <tr>
                                            <th>Ward</th>
                                            <td>{ward ? ward : "Not Available"}</td>
                                            <th>Ward No</th>
                                            <td>{wardno ? wardno : "Not Available"}</td>
                                        </tr>
                                        <tr>
                                            <th>Total Children</th>
                                            <td>{total_children ? total_children : "Not Available"}</td>
                                            <th>Total Male Children</th>
                                            <td>{total_male_children ? total_male_children : "Not Available"}</td>
                                            
                                        </tr>
                                        <tr>
                                            <th>Total Female Children</th>
                                            <td>{total_female_children ? total_female_children : "Not Available"}</td>
                                        </tr>
                                    </tbody>
                                }
                               
                            </Table>
                        </Col>
                    </Row>


                    {/* <Table className="mt-1" bordered striped>
                        <tbody>
                            <tr>
                                <th>Latitude</th>
                                <td>{latitude ? latitude : "Not Available"}</td>
                                <th>Longitude</th>
                                <td>{longitude ? longitude : "Not Available"}</td>
                            </tr>
                            <tr>
                                <th>City</th>
                                <td>{city ? city : "Not Available"}</td>
                                <th>State</th>
                                <td>{state ? state : "Not Available"}</td>
                            </tr>

                            <tr>
                                <th>Locality</th>
                                <td>{locality ? locality : "Not Available"}</td>
                                <th>Vendor</th>
                                <td>{vendor ? vendor : "Not Available"}</td>
                            </tr>

                        </tbody>
                    </Table> */}
                </CardBody>
            </Card>
        </Container>
    }
}

const mapStateToProps = (state) => {
    return {
        cartItems: state.cart.cartItems,
    }
}

export default connect(mapStateToProps, { addToCart })(WardMapInfoBox);


// WEBPACK FOOTER //
// ./src/v3/components/createCampaign/mapWardInfoBox.js